import { useState } from 'react';
import AuthAPI from '../../auth/api/AuthAPI';
import useToaster from '../../toaster/hooks/useToaster';
import useUserService from '../../auth/hooks/useUserService';
import { ReAuthoriseNodeConfirmationData } from '../components/ReAuthoriseNodeConfirmation';

interface AuthData {
  nodeType: string;
  authProvider?: string;
  oAuthTokenId: number;
  oAuthUserId: number;
}

export function useReAuthoriseNode() {
  const [
    reAuthoriseNodeConfirmationData,
    setReAuthoriseNodeConfirmationData
  ] = useState<ReAuthoriseNodeConfirmationData>({
    visible: false
  });

  const [ authData, setAuthData ] = useState<AuthData>(null);

  const { user } = useUserService();
  const toaster = useToaster();

  const reAuthorise = ({
    confirmBody,
    nodeType,
    authProvider,
    oAuthTokenId,
    oAuthUserId,
    BodyComponent
  }: {
    confirmBody?: string;
    nodeType: string;
    authProvider?: string;
    oAuthTokenId: number;
    oAuthUserId: number;
    BodyComponent?: any;
  }) => {
    const _authData = {
      nodeType,
      authProvider,
      oAuthTokenId,
      oAuthUserId
    };

    setAuthData(_authData);

    if (isConfirmationRequiredToReauthorise(_authData)) {
      setReAuthoriseNodeConfirmationData({
        visible: true,
        body: confirmBody,
        BodyComponent: BodyComponent
      });

      return;
    }

    doReAuthorise(_authData);
  };

  const onReAuthoriseNodeConfirmationClose = (confirm?: boolean) => {
    setReAuthoriseNodeConfirmationData({
      ...reAuthoriseNodeConfirmationData,
      visible: false
    });

    if (confirm) {
      doReAuthorise(authData);
    }
  };

  const doReAuthorise = (data: AuthData) => {
    AuthAPI.reAuthoriseAccount(
      data.authProvider || data.nodeType,
      data.oAuthTokenId,
      window.location.href,
      window.location.href
    ).then((res: any) => {
      if (res && res.data && res.data.consent_url) {
        window.location.assign(res.data.consent_url);
        return;
      }

      toaster.pop(
        'error',
        undefined,
        'Couldn\'t reauthorize this account'
      );
    }, (err) => {
      // ..
    });
  };

  const isConfirmationRequiredToReauthorise = (options) => {
    const currentUserId = user.id;
    return options.oAuthUserId !== currentUserId || options.nodeType === 'YOUTUBE_ANALYTICS';
  };

  return {
    reAuthorise,
    reAuthoriseNodeConfirmationData,
    onReAuthoriseNodeConfirmationClose
  };
}
